import {
  SET_APPLICATION_MODE,
  SET_DEBUG_LEVEL,
  SET_TRANSLATION_MODE,
  LOAD_APPLICATION,
  SET_LOAD_PLAN_FROM_LINK_ERROR,
  SET_LOAD_LOCAL_PLAN_ERROR,
  SET_SAVE_ERROR,
  SHOW_PRICE_DIFFERENCE_DIALOG,
  HIDE_PRICE_DIFFERENCE_DIALOG,
  PLAN_LOADING,
  RESET_DIALOGS,
  DISPLAY_VIRTUAL_KEYBOARD,
  SHOW_PLAN_SAVED_DIALOG,
  CLOSE_PLAN_SAVED_DIALOG,
  DISABLE_PRICE_ANIMATION,
  SHOW_NEW_FEATURES_DIALOG,
  SHOW_NEW_FEATURES_TOAST,
  DISPLAY_PRINT_FORMAT,
  SET_IPEXGALLERY_MODE,
  SET_UPPTACKA_MODE,
  SET_IDLE_TIME,
  SET_KIOSK_PRINT_MODE
} from './constants';

export function setApplicationMode(mode) {
  return {
    type: SET_APPLICATION_MODE,
    mode,
  };
}

export function setDebugLevel(debugLevel) {
  return {
    type: SET_DEBUG_LEVEL,
    debugLevel,
  };
}

export function displayPrintFormat() {
  return {
    type: DISPLAY_PRINT_FORMAT,
  };
}

export function setTranslationMode(translationMode) {
  return {
    type: SET_TRANSLATION_MODE,
    translationMode,
  };
}

export function loadApplication() {
  return {
    type: LOAD_APPLICATION,
  };
}

export function setLoadPlanFromLinkError(error) {
  return {
    type: SET_LOAD_PLAN_FROM_LINK_ERROR,
    error,
  };
}

export function setLoadLocalPlanError(error) {
  return {
    type: SET_LOAD_LOCAL_PLAN_ERROR,
    error,
  };
}

export function setSaveError(error) {
  return {
    type: SET_SAVE_ERROR,
    error,
  };
}

export function planLoading(loading) {
  return {
    type: PLAN_LOADING,
    loading,
  };
}

export function showPriceDifferenceDialog(oldPrice, oldFamilyPrice, oldCurrency, oldCountry) {
  return {
    type: SHOW_PRICE_DIFFERENCE_DIALOG,
    oldPrice,
    oldFamilyPrice,
    oldCurrency,
    oldCountry,
  };
}

export function hidePriceDifferenceDialog() {
  return {
    type: HIDE_PRICE_DIFFERENCE_DIALOG,
  };
}

export function resetDialogs() {
  return {
    type: RESET_DIALOGS,
  };
}

export function displayVirtualKeyboard(display) {
  return {
    type: DISPLAY_VIRTUAL_KEYBOARD,
    display,
  };
}

export function disablePriceAnimation(disable) {
  return {
    type: DISABLE_PRICE_ANIMATION,
    disable,
  };
}

export function closePlanSavedDialog() {
  return {
    type: CLOSE_PLAN_SAVED_DIALOG,
  };
}


export function showPlanSavedDialog() {
  return {
    type: SHOW_PLAN_SAVED_DIALOG,
  };
}

export function showNewFeaturesDialog(show) {
  return {
    type: SHOW_NEW_FEATURES_DIALOG,
    show,
  };
}

export function showNewFeaturesToast(show) {
  return {
    type: SHOW_NEW_FEATURES_TOAST,
    show,
  };
}

export function setIpexGalleryMode(mode) {
  return {
    type: SET_IPEXGALLERY_MODE,
    mode,
  };
}

export function setUpptackaMode(mode) {
  return {
    type: SET_UPPTACKA_MODE,
    mode,
  };
}

export function setIdleTime(time) {
  return {
    type: SET_IDLE_TIME,
    time,
  };
}

export function setKioskPrintMode(mode) {
  return {
    type: SET_KIOSK_PRINT_MODE,
    mode,
  };
}
